module.exports = __webpack_public_path__ + "img/image26.f65ca017.jpg";